import { styled } from "@mui/material/styles";
import { Grid } from '@mui/material';

export const RootContainer = styled(Grid)(({ theme }) => ({
  width: '100%',
  minHeight: '100%',
}));

export const TabContainer = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const ContentContainer = styled(Grid)({
  width: '100%',
});

export const EmailFormContainer = styled('div')(({ theme }) => ({
  width: '100%',
  '& > *': {
    marginTop: theme.spacing(1),
  },
}));

export const ResultsContainer = styled('div')({
  width: '100%',
  overflowX: 'auto',
}); 